import React from 'react';
import FirstPageIcon from '@material-ui/icons/FirstPage';
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import './styles.scss';

const emptyFunction = () => {};
interface IProps {
  currentPage: number;
  totalRecords: number;
  perPage: number;
  onClickNextPage: () => void;
  onClickPrevPage: () => void;
  onClickFirstPage?: () => void;
  dataTestId?: string;
  isLoading?: boolean;
}

const Pagination = (props: IProps) => {
  const calculateCurrentRecord = (
    totalRecords: number,
    currentPage: number,
    perPage: number,
  ) => {
    const currentRecord =
      totalRecords > 0 ? perPage * (currentPage - 1) + 1 : 0;
    let isAbleToNext = true;
    let lastRecord = perPage * currentPage;
    if (lastRecord >= totalRecords) {
      lastRecord = totalRecords;
      isAbleToNext = false;
    }
    return {
      currentRecord,
      lastRecord,
      isAbleToNext,
      isAbleToPrev: currentPage > 1,
    };
  };

  const {
    totalRecords,
    currentPage,
    perPage,
    onClickNextPage,
    onClickPrevPage,
    onClickFirstPage,
    dataTestId,
    isLoading,
  } = props;
  const { currentRecord, lastRecord, isAbleToNext, isAbleToPrev } =
    calculateCurrentRecord(totalRecords, currentPage, perPage);

  return (
    <div data-testid={dataTestId} styleName="pagination-wrapper">
      <div styleName="indicator">
        {currentRecord} - {lastRecord} of {totalRecords}
      </div>
      <div styleName="navigation-icons">
        <div
          data-testid="first-page-indicator"
          styleName="icon"
          onClick={isAbleToPrev ? onClickFirstPage : emptyFunction}
        >
          <FirstPageIcon
            color={isAbleToPrev && !isLoading ? 'inherit' : 'disabled'}
          />
        </div>
        <div
          data-testid="prev-page-indicator"
          styleName="icon"
          onClick={isAbleToPrev ? onClickPrevPage : emptyFunction}
        >
          <NavigateBeforeIcon
            color={isAbleToPrev && !isLoading ? 'inherit' : 'disabled'}
          />
        </div>
        <div
          data-testid="next-page-indicator"
          styleName="icon"
          onClick={isAbleToNext ? onClickNextPage : emptyFunction}
        >
          <NavigateNextIcon
            color={isAbleToNext && !isLoading ? 'inherit' : 'disabled'}
          />
        </div>
      </div>
    </div>
  );
};

export default Pagination;
